import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flattenHTMLToAppURL } from '@plone/volto/helpers';
import { GoogleMap } from '@package/components';
import { UniversalLink } from '@plone/volto/components';
import { Icon } from 'semantic-ui-react';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  startingPoint: { id: 'Starting point', defaultMessage: 'Punto di partenza' },
});
const Location = ({ content, intl }) => {
  const getTextareaHTML = (text) => {
    if (text) {
      return text.split(/\r|\n/).join('<br/>');
    }
    return '';
  };

  let coordinates = null;
  let venues = null;

  const hasLocation =
    content.geolocation && Object.keys(content.geolocation).length > 0;

  if (hasLocation) {
    coordinates =
      parseFloat(content.geolocation.lat) +
      ',' +
      parseFloat(content.geolocation.lng);

    venues = [
      {
        lat: parseFloat(content.geolocation.lat),
        lng: parseFloat(content.geolocation.lng),
        title:
          content['@type'] === 'Esperienza'
            ? intl.formatMessage(messages.startingPoint)
            : null,
      },
    ];
  }

  if (content['@type'] === 'Esperienza' && content.route?.length > 0) {
    if (!venues) {
      venues = [];
    }
    content.route.forEach((route) => {
      if (route.latitude && route.longitude) {
        venues.push({
          lat: parseFloat(route.latitude),
          lng: parseFloat(route.longitude),
          title: route.name,
        });
      }
    });
    if (venues?.length > 0) {
      venues.map((v, idx) => {
        v.marker = <div className="marker-number">{idx + 1}</div>;
      });
    }
  }

  return (
    <>
      {(content.where || hasLocation || content.area || venues?.length > 0) && (
        <section className="info-box no-bg center">
          <div className="info-box-header">
            <FormattedMessage id="WHERE WE ARE" defaultMessage="DOVE" />
          </div>

          {content.where ||
            (content.area?.title && (
              <div className="info-box-text">
                {content.area?.title && (
                  <div className="area">{content.area.title}</div>
                )}

                {content.where && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: flattenHTMLToAppURL(
                        getTextareaHTML(content.where),
                      ),
                    }}
                  />
                )}
              </div>
            ))}

          {(hasLocation || venues?.length > 0) && (
            <>
              <div className="map-description">
                {content.municipality?.title && (
                  <div>{content.municipality?.title}</div>
                )}
                {content.geolocation?.description}
              </div>
              <div className="map">
                <GoogleMap
                  showTitle={false}
                  showPrice={false}
                  height="450px"
                  venues={venues}
                />
              </div>
              {content['@type'] === 'Esperienza' && (
                <div className="go-to-start my-2">
                  <UniversalLink
                    href={
                      'https://www.google.com/maps/place/' +
                      coordinates +
                      '/@' +
                      coordinates +
                      ',15.2z'
                    }
                    rel="noopener noreferrer"
                    target="_blank"
                    className="ui button buttonLink red small"
                  >
                    <FormattedMessage
                      id="Vai al punto di partenza"
                      defaultMessage="Vai al punto di partenza"
                    />
                    <Icon name="location arrow" />
                  </UniversalLink>
                </div>
              )}
            </>
          )}
        </section>
      )}
    </>
  );
};
export default injectIntl(Location);
